import * as React from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import { IconButton } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useSelector } from "react-redux";

export default function BasicModal({
  children,
  show,
  unShow,
  width,
  height,
  overflowY,
}) {

    const userTheme = useSelector((state) => state.commonSlice.theme);
  const style = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: width || 400,
    height: height,
    overflowY: overflowY ? "scroll" : "auto",
    bgcolor: userTheme=='dark'?"rgba(255, 255, 255, 0.15)":"rgba(255, 255, 255, 0.52)",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    borderRadius: 6,
    p: 4,
  };

  const iconStyle = {
    justifyContent: "flex-end",
    position: "fixed",
    zIndex: 777777,
    top: "4px",
    right: "7px",
    width: 10,
  };

  return (
    <div>
      <Modal
        open={show}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <SoftBox sx={style} className="scrollable-modal-content">
          <IconButton
            onClick={() => unShow(false)}
            color="error"
            sx={iconStyle}
            component="div"
            size="large"
          >
            <CancelPresentationIcon />
          </IconButton>

          <SoftBox>{children}</SoftBox>
        </SoftBox>
      </Modal>
    </div>
  );
}

BasicModal.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  unShow: PropTypes.func.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  overflowY: PropTypes.bool,
};
